import React from "react";
import { motion } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

export const PrimaryCTA = ({
  children = "Richiedi l'analisi gratuita",
  target = "contatti",
  testId = "cta-primary",
  className = "",
}) => (
  <motion.button
    data-testid={testId}
    onClick={() => scrollToId(target)}
    whileHover={{ y: -2 }}
    whileTap={{ scale: 0.98 }}
    className={`group inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 font-display text-sm font-semibold tracking-wide text-navy-deep shadow-[0_10px_30px_rgba(201,162,39,0.35)] transition-colors duration-300 hover:bg-amber hover:text-white ${className}`}
  >
    {children}
    <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
  </motion.button>
);
